module.exports = __webpack_public_path__ + "img/19.55ad437d.jpg";